<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <h3 class="text-center">{{ programa_name }}</h3>
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <span>Lista de retrasos</span>
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="openregistrar()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.movimiento`]="{ item }">
          <span v-if="item.movimiento == 'reversion'"> {{ item.movimiento }} </span>
          <b v-else> {{ item.movimiento }} </b>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-2" color="orange" small v-bind="attrs" v-on="on" @click="veritem(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver detalles </span>
          </v-tooltip>

          <v-tooltip bottom v-if="item.movimiento == 'insertado'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="red" small v-bind="attrs" v-on="on" @click="prerevertir(item)">
                mdi-close
              </v-icon>
            </template>
            <span> Revertir </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <Registrar ref="registrarref" v-on:onreg="onreg" />
    <Ver ref="verref" />
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import Registrar from '@/views/retrasos/agregar.vue';
  import Ver from '@/views/retrasos/view.vue';
  export default {
    data: () => ({
      loading: false,
      programa_name: '',

      headers: [
        { text: 'Nro', value: 'nro', width: 20 },
        { text: 'Dias retraso', value: 'dias_retraso' },
        { text: 'Motivo', value: 'motivo' },
        //{ text: 'Est. Afectados', value: 'est_afectados' },
        { text: 'Movimiento', value: 'movimiento' },
        { text: 'Cuota afectada', value: 'cuota_afectada' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 140 },
      ],
      desserts: [],
    }),
    components: { Registrar, Ver },
    computed: {},
    watch: {},
    methods: {
      openregistrar() {
        this.$refs.registrarref.openmodal();
      },
      listarByPrograma() {
        this.loading = true;
        this.desserts = [];
        let vue = this;
        let idp = parseInt(this.$route.query.idprograma);
        var config = {
          method: 'get',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/retraso/programas`,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/retraso/programas?programa=${idp}`,
          headers: {},
          data: this.input,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.sort((a, b) => {
              return a.movimiento.localeCompare(b.movimiento);
            });
            data.map((x, i) => {
              x.nro = i + 1;
              x.dias_retraso = `${x.cantidad_retraso} ${x.tipo_retraso}`;
            });
            window.console.log(data);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      veritem(item) {
        this.$refs.verref.openmodal(item.id);
      },
      onreg() {
        this.listarByPrograma();
      },
      async prerevertir(item) {
        this.loading = true;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/retraso/programas/revertir`;
        let texto = `no hay vuelta atras`;

        let message = {
          title: `confirmacion necesaria:`,
          body: texto,
        };
        var opt = {
          verification: 'revertir',
          verificationHelp: 'Escriba "[+:verification]" para proceder.',
          okText: 'Proceder',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        let dialogo = await this.$dialog
          .confirm(message, opt)
          .then((dialog) => dialog)
          .catch(() => {});
        if (!dialogo) return;

        let vue = this;
        let us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        var config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            id: item.id,
            realizado_por: `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim(),
          },
        };

        xaxios.request(config)
          .then(({ data }) => {
            window.console.log(data);
            vue.loading = false;
            vue.listarByPrograma();
            dialogo.close();
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
            dialogo.close();
          });
      },
    },
    mounted() {
      //window.console.log('this.$router', this.$route.query);
      this.programa_name = this.$route.query.p;
      this.listarByPrograma();
    },
  };
</script>
